import { render, staticRenderFns } from "./WebSiteConfig.vue?vue&type=template&id=4c8cfefa&scoped=true&"
import script from "./WebSiteConfig.vue?vue&type=script&lang=js&"
export * from "./WebSiteConfig.vue?vue&type=script&lang=js&"
import style0 from "./WebSiteConfig.vue?vue&type=style&index=0&id=4c8cfefa&prod&scoped=true&lang=css&"
import style1 from "./WebSiteConfig.vue?vue&type=style&index=1&id=4c8cfefa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8cfefa",
  null
  
)

export default component.exports